export default __webpack_public_path__ + "static/media/refresh.1b0b2a7e.svg";